<template>
  <div class="loading" v-if="isShow.isLDShow">
    <div class="ld-wp">
      <div class="ld-title"></div>
      <div class="ld-cup"></div>
      <p>{{loadingNum}}%</p>
      <div class="ld-logo"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: Object
  },
  data () {
    return {
      loadingNum: 0,
      imgArr: [],
      preLoadImg: [{"src":require('../../pages/loading/img/logo.png')},{"src": require('../../components/longImage/img/qr-group.png')},{"src":require('../../components/longImage/img/s1-bg.jpg')},{"src":require('../../components/longImage/img/s1-coffee.png')},{"src":require('../../components/longImage/img/s1-loading.png')},{"src":require('../../components/longImage/img/s1-steam1.png')},{"src":require('../../components/longImage/img/s1-steam2.png')},{"src":require('../../components/longImage/img/s1-title.png')},{"src":require('../../components/longImage/img/s10-bg.jpg')},{"src":require('../../components/longImage/img/s10-dialog.png')},{"src":require('../../components/longImage/img/s10-person.png')},{"src":require('../../components/longImage/img/s10-pot.png')},{"src":require('../../components/longImage/img/s11-bg.jpg')},{"src":require('../../components/longImage/img/s11-hour.png')},{"src":require('../../components/longImage/img/s11-min.png')},{"src":require('../../components/longImage/img/s11-txt1.png')},{"src":require('../../components/longImage/img/s11-txt2.png')},{"src":require('../../components/longImage/img/s11-txt3.png')},{"src":require('../../components/longImage/img/s11-txt4.png')},{"src":require('../../components/longImage/img/s11-txt5.png')},{"src":require('../../components/longImage/img/s11-txt6.png')},{"src":require('../../components/longImage/img/s11-txt7.png')},{"src":require('../../components/longImage/img/s12-bg.jpg')},{"src":require('../../components/longImage/img/s12-dialog.png')},{"src":require('../../components/longImage/img/s13-bg.jpg')},{"src":require('../../components/longImage/img/s13-face1.png')},{"src":require('../../components/longImage/img/s13-face2.png')},{"src":require('../../components/longImage/img/s13-face3.png')},{"src":require('../../components/longImage/img/s13-qr.png')},{"src":require('../../components/longImage/img/s13-slogan.png')},{"src":require('../../components/longImage/img/s13-txt1.png')},{"src":require('../../components/longImage/img/s2-arrows.png')},{"src":require('../../components/longImage/img/s2-bg.jpg')},{"src":require('../../components/longImage/img/s2-calendar.png')},{"src":require('../../components/longImage/img/s2-coffee-steam1.png')},{"src":require('../../components/longImage/img/s2-coffee-steam2.png')},{"src":require('../../components/longImage/img/s2-coffee.png')},{"src":require('../../components/longImage/img/s2-computer.png')},{"src":require('../../components/longImage/img/s2-dialog.png')},{"src":require('../../components/longImage/img/s2-keyboard.png')},{"src":require('../../components/longImage/img/s2-leaf.png')},{"src":require('../../components/longImage/img/s2-notes.png')},{"src":require('../../components/longImage/img/s2-rabbits.png')},{"src":require('../../components/longImage/img/s3-bg.jpg')},{"src":require('../../components/longImage/img/s3-breeze1.png')},{"src":require('../../components/longImage/img/s3-breeze2.png')},{"src":require('../../components/longImage/img/s3-dialog1.png')},{"src":require('../../components/longImage/img/s3-dialog2.png')},{"src":require('../../components/longImage/img/s3-dialog3.png')},{"src":require('../../components/longImage/img/s3-dialog4.png')},{"src":require('../../components/longImage/img/s3-hand.png')},{"src":require('../../components/longImage/img/s3-leaf1.png')},{"src":require('../../components/longImage/img/s3-leaf2.png')},{"src":require('../../components/longImage/img/s3-mouth1.png')},{"src":require('../../components/longImage/img/s3-mouth2.png')},{"src":require('../../components/longImage/img/s3-mouth3.png')},{"src":require('../../components/longImage/img/s3-mouth4.png')},{"src":require('../../components/longImage/img/s3-person.png')},{"src":require('../../components/longImage/img/s3-rabbit1.png')},{"src":require('../../components/longImage/img/s3-rabbit2.png')},{"src":require('../../components/longImage/img/s3-rabbit3.png')},{"src":require('../../components/longImage/img/s3-sound.png')},{"src":require('../../components/longImage/img/s4-bg.jpg')},{"src":require('../../components/longImage/img/s4-dialog.png')},{"src":require('../../components/longImage/img/s4-hour.png')},{"src":require('../../components/longImage/img/s4-min.png')},{"src":require('../../components/longImage/img/s4-pop.png')},{"src":require('../../components/longImage/img/s5-bg.jpg')},{"src":require('../../components/longImage/img/s5-dialog.png')},{"src":require('../../components/longImage/img/s5-left-hand1.png')},{"src":require('../../components/longImage/img/s5-left-hand2.png')},{"src":require('../../components/longImage/img/s5-para.png')},{"src":require('../../components/longImage/img/s5-rabbit.png')},{"src":require('../../components/longImage/img/s5-right-hand.png')},{"src":require('../../components/longImage/img/s6-bg.jpg')},{"src":require('../../components/longImage/img/s6-bulb.png')},{"src":require('../../components/longImage/img/s6-dialog1.png')},{"src":require('../../components/longImage/img/s6-dialog2.png')},{"src":require('../../components/longImage/img/s6-dialog3.png')},{"src":require('../../components/longImage/img/s6-dialog4.png')},{"src":require('../../components/longImage/img/s7-bg.jpg')},{"src":require('../../components/longImage/img/s7-dialog.png')},{"src":require('../../components/longImage/img/s7-q1.png')},{"src":require('../../components/longImage/img/s7-q2.png')},{"src":require('../../components/longImage/img/s7-q3.png')},{"src":require('../../components/longImage/img/s7-q4.png')},{"src":require('../../components/longImage/img/s8-bg.jpg')},{"src":require('../../components/longImage/img/s8-qa1.png')},{"src":require('../../components/longImage/img/s8-qa2.png')},{"src":require('../../components/longImage/img/s8-qa3.png')},{"src":require('../../components/longImage/img/s8-qb1.png')},{"src":require('../../components/longImage/img/s8-qb2.png')},{"src":require('../../components/longImage/img/s8-qb3.png')},{"src":require('../../components/longImage/img/s9-bg.jpg')},{"src":require('../../components/longImage/img/s9-dialog1.png')},{"src":require('../../components/longImage/img/s9-dialog2.png')},{"src":require('../../components/longImage/img/s9-dialog3.png')},{"src":require('../../components/musicPlayer/img/music-off.png')},{"src":require('../../components/musicPlayer/img/music-on.png')},{"src":require('../../components/rotate/img/rt-direction.png')},{"src":require('../../components/rotate/img/rt-fail.png')},{"src":require('../../components/rotate/img/rt-success.png')}]
    }
  },
  methods: {
    generateId (index) {
      return 'mImg' + index
    },
    go () {
      this.$emit('nextPage', 'isKVShow')
    },
    loadNextImg(imgID){
      const _this = this
      const len = this.preLoadImg.length
      const curSrc = this.preLoadImg[imgID].src
      let curImg = new Image()
      curImg.onload = function () {
        imgID++
        _this.loadingNum = parseInt(imgID / len * 100)
        if (imgID < len) {
          _this.loadNextImg(imgID)
        } else {
          // console.log('completed')
          _this.go()
        }
      }
      curImg.src = curSrc
    }
  },
  mounted () {
    let imgID = 0
    setTimeout(() => {
      this.loadNextImg(imgID)
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.bg() {
  background-size: cover;
  background-repeat: no-repeat;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  .bg();
  background-image: url('./img/bg.jpg');
}

.ld-wp {
  display: flex;
  flex-direction: column;
  align-items: center;
  transform-origin: center;
  transform: scale(.6);
}

.ld-title {
  width: 43.1875/2rem /* 691/16 */;
  height: 3.1875rem /* 51/16 */;
  .bg();
  background-image: url('./img/s1-title.png');
}

.ld-cup {
  margin: 2.5rem /* 40/16 */ 1.25rem /* 20/16 */;
  width: 7.625/2rem /* 122/16 */;
  height: 12.6875/2rem /* 203/16 */;
  .bg();
  background-image: url('./img/s1-coffee.png');
}
p {
  margin-bottom: 1.25rem /* 20/16 */;
  text-align: center;
  font-size: 18px;
}

.ld-logo {
  width: 165.5px;
  height: 46px;
  .bg();
  background-image: url('./img/loading-group.png');
  animation: move 1s forwards steps(4, end) infinite;
}


@keyframes move {
  0% {
    background-position-y: 0;
  }
  100% {
    background-position-y: -184px;
  }
}

@media screen and (min-height: 650px) {
  .ld-wp {
    margin-bottom: 6rem;
  }
}
</style>
